import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning_4bd214",
  "use": "icon-warning_4bd214-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"icon-warning_4bd214\">\n  <defs>\n    <style>\n      #icon-warning_4bd214 .cls-1, #icon-warning_4bd214 .cls-2 {\n        fill: #4bd214;\n      }\n\n      #icon-warning_4bd214 .cls-2 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-2\" d=\"m10.5,19.5c4.97,0,9-4.03,9-9S15.47,1.5,10.5,1.5,1.5,5.53,1.5,10.5s4.03,9,9,9Zm0,1.5c5.8,0,10.5-4.7,10.5-10.5S16.3,0,10.5,0,0,4.7,0,10.5s4.7,10.5,10.5,10.5Z\" />\n  <path class=\"cls-2\" d=\"m10.5,3.6c.5,0,.9.4.9.9v8c0,.5-.4.9-.9.9s-.9-.4-.9-.9v-8c0-.5.4-.9.9-.9Z\" />\n  <path class=\"cls-1\" d=\"m11.7,15.15c0,.64-.51,1.15-1.15,1.15s-1.15-.51-1.15-1.15.51-1.15,1.15-1.15,1.15.51,1.15,1.15Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/warning_4bd214.svg
// module id = sANq
// module chunks = 87